<template>
    <div class="icon-process-wrapper">
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-fire"></i>
                </div>
                <h5 class="icon-process-single__title">{{$t('fikirlerinizitanimlayin')}}</h5>
                <div class="icon-process-single__text">
                    {{$t('fikirlerinizitanimlayinslogan')}}
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-users"></i>
                </div>
                <h5 class="icon-process-single__title">{{$t('tasarimlarustundecalisma')}}</h5>
                <div class="icon-process-single__text">
                    {{$t('tasarimlarustundecalismaslogan')}}
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-chart-line"></i>
                </div>
                <h5 class="icon-process-single__title">{{$t('kodlamavegozdengecirme')}}</h5>
                <div class="icon-process-single__text">
                    {{$t('kodlamavegozdengecirmeslogan')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Gradation',
    };
</script>
